import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import ShowIfAllowed from '../../../components/common/show-if-allowed';
import Table from '../../../components/common/table/table';
import Title from '../../../components/common/title';
import { LinkComponent as Link } from '../../../components/form/elements/link';
import Maintenance from '../../../interfaces/maintenance';
import {
  EQUIPMENT_MAINTENANCE_CREATE,
  EQUIPMENT_MAINTENANCE_VIEW,
} from '../../../router/routes';
import { useService } from '../../../services/services';
import { route } from '../../../services/utils';
import css from './index.module.css';

export default function MaintenanceAndRepairs() {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const { maintenanceService } = useService();

  const transKeyPrefix = 'pages.equipment.maintenance.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      maintenanceService.index(farmId, { page, sort, desc, ...filter }),
    [maintenanceService, farmId]
  );

  return (
    <div className={css['index']}>
      <Title title={tp('title')} />
      <div className={css['body']}>
        <ShowIfAllowed ability={{ title: 'create maintenance' }}>
          <div className={css['toolbar']}>
            <div className={css['left']}>
              <div>
                <Link
                  label="add"
                  primary={true}
                  linkTo={route(EQUIPMENT_MAINTENANCE_CREATE, { farmId })}
                  icon={faPlus}
                />
              </div>
            </div>
          </div>
        </ShowIfAllowed>
        <Table<Maintenance>
          request={request}
          keyAccessor="id"
          columns={[
            {
              accessor: 'date',
              header: tp('date'),
              sortable: true,
              className: css['strong'],
            },
            {
              accessor: 'equipment_label',
              header: tp('equipment'),
              sortable: true,
              className: css['strong'],
            },
            {
              accessor: 'name',
              header: tp('name'),
              className: css['strong'],
            },
            {
              accessor: 'employee_full_name',
              header: tp('employee'),
              sortable: true,
            },
            { accessor: 'spent_time', header: tp('spent_time') },
            { accessor: 'used_materials', header: tp('used_materials') },
            { accessor: 'material_cost', header: tp('material_cost') },
          ]}
          viewRoute={route(EQUIPMENT_MAINTENANCE_VIEW, { farmId })}
          viewRecordAbility={{ title: 'view maintenance' }}
        />
      </div>
    </div>
  );
}
